import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { configurationApi, type FeatureFlag } from '../../api/configuration';

export function FeatureFlagManagerPage() {
  const [flags, setFlags] = useState<FeatureFlag[]>([]);
  const [error, setError] = useState('');

  function load() {
    void configurationApi.listFlags().then((r) => setFlags(r.flags)).catch((e) => setError(String(e)));
  }

  useEffect(() => { load(); }, []);

  async function toggle(id: string, enabled: boolean) {
    try {
      await configurationApi.updateFlag(id, { enabled: !enabled });
      load();
    } catch (e) {
      setError(String(e));
    }
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/configuration" className="text-sm text-blue-600 hover:underline">← Configuration Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Feature Flag Manager</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 space-y-3">
        {flags.map((f) => (
          <div key={f.id} className="flex items-center justify-between rounded-xl border p-4 dark:border-slate-700">
            <div>
              <p className="font-medium">{f.name}</p>
              <p className="text-sm font-mono text-slate-500">{f.key}</p>
              <p className="text-xs text-slate-400">{f.type} · rollout {f.rollout_percent ?? 0}%</p>
            </div>
            <button type="button" onClick={() => void toggle(f.id, f.enabled)} className={`rounded px-3 py-1 text-sm ${f.enabled ? 'bg-green-100 text-green-800' : 'bg-slate-100 text-slate-600'}`}>
              {f.enabled ? 'Enabled' : 'Disabled'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
